import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation, useQueryClient } from 'react-query'
import useEventLogger from '../hooks/useEventLogger'
import { SNAPSHOTS_QUERY_KEY } from './useGetSnapshotsQuery'
import { useStrategy } from '../hooks/useStrategy'

type Snapshot = {
    snapshotSourceId: string
    snapshotNote: string
}

export const useCreateSnapshotMutation = () => {
    const { logEvent, ACTIONS } = useEventLogger()
    const { getTokenSilently } = useAuth0()
    const queryClient = useQueryClient()
    const strategy = useStrategy()
    const sourceId = strategy?.sourceId ?? strategy?._id

    const createSnapshot = async ({ snapshotSourceId, snapshotNote }) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.createSnapshot

        const postObject: Snapshot = {
            snapshotSourceId: snapshotSourceId,
            snapshotNote: snapshotNote,
        }

        logEvent(ACTIONS.SNAPSHOT, {})
        const response = await callAPI(url, method, token, postObject)

        if (!response.success) {
            throw new Error(response.error || 'Server responded with error when creating snapshot')
        }
    }

    return useMutation(createSnapshot, {
        onSuccess: () => {
            queryClient.invalidateQueries([SNAPSHOTS_QUERY_KEY, sourceId])
        },
    })
}
